import request from '@/utils/request';

export function listUser(query?) {
    return request({
        url: '/system/third/user/list',
        method: 'get',
        params: query
    });
}

export function addUser(data) {
    return request({
        url: '/system/third/user/add',
        method: 'post',
        data: data
    });
}

export function getUser(appId) {
    return request({
        url: '/system/third/user/get/' + appId,
        method: 'get'
    });
}

export function updateUser(data) {
    return request({
        url: '/system/third/user/edit/',
        method: 'put',
        data: data
    });
}

export function delUser(appIds) {
    return request({
        url: '/system/third/user/remove/' + appIds,
        method: 'delete'
    });
}

export function clearCache() {
    return request({
        url: '/system/third/user/clearCache',
        method: 'delete'
    });
}

export function changeUserStatus(appId, status) {
    const data = {
        appId,
        status
    };
    return request({
        url: '/system/third/user/changeStatus',
        method: 'put',
        data: data
    });
}

export function resetSecretKey(appId) {
    return request({
        url: '/system/third/user/reset/' + appId,
        method: 'put'
    });
}
